/**
 * Whether this page should send anything to PostHog or Meta at all.
 *
 * Dev servers read the real `.env.local`, so every worktree, every preview pane
 * and every phone on the Wi-Fi used to land in the same PostHog project as the
 * people the ads bought — about as many sessions as prod, by October. So a page
 * on a local or private-network host, or one driven by an automated browser
 * (`navigator.webdriver`), sends nothing. `VITE_ANALYTICS_LOCAL=on` sends anyway,
 * for the afternoon you are working on the analytics themselves.
 */
const LOCAL_HOST = /^(localhost|.*\.localhost|127\.\d+\.\d+\.\d+|10\.\d+\.\d+\.\d+|192\.168\.\d+\.\d+|172\.(1[6-9]|2\d|3[01])\.\d+\.\d+|\[::1\]|0\.0\.0\.0)$/;

export function isLocalHost(hostname: string): boolean {
  return LOCAL_HOST.test(hostname);
}

export function trackingAllowed(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  webdriver = typeof navigator !== 'undefined' && !!navigator.webdriver,
  override = (import.meta.env.VITE_ANALYTICS_LOCAL as string | undefined) === 'on',
): boolean {
  if (override) return true;
  return !webdriver && !isLocalHost(hostname);
}
